const routes = {
  tourOperatorCreate: "/tour-operators/create",
  tourOperatorUpdate: "/tour-operators/:id/update",
  tourOperatorDelete: "/tour-operators/:id/delete",
  tourOperatorDetail: "/tour-operators/:id",
  tourOperatorList: "/tour-operators",
}

export default routes
